import { parseISO } from "date-fns";
import * as styles from "components/layout/Search/Results/Results.module.scss";
import { Countdown } from "components/layout/Countdown";
import { Icon } from "library";
import { Link } from "components/Link";
import React from "react";
import { useEvent } from "hooks/firestore/v2/betting/useEvent";
import { ReactComponent as PromoIcon } from "components/assets/icon-promo-inside.svg";
import { useDebounce } from "usehooks-ts";

type RowsProps = {
  icon: React.ReactNode;
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  highlight?: React.ReactNode;
  to?: string;
  startTime?: string;
  eventId: string;
};

export const Row = ({
  icon,
  title,
  subTitle,
  highlight,
  to,
  startTime,
  eventId,
}: RowsProps) => {
  // debouncing eventId here is important for input and results performance as it
  // helps reduce the number of requests being sent while the user is typing
  const debouncedEventId = useDebounce(eventId, 100);
  const { event } = useEvent(debouncedEventId, "all");

  const parsedStartTime = startTime ? parseISO(startTime) : null;
  const shouldShowButtons = Boolean(to) || Boolean(startTime);

  const rowContents = (
    <>
      <div className={styles.iconWrapper}>
        <div className={styles.icon}>{icon}</div>

        {event?.showPromoBanner && (
          <div className={styles.promoIcon}>
            <PromoIcon />
          </div>
        )}
      </div>

      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
        {highlight && <div>{highlight}</div>}
      </div>

      {shouldShowButtons && (
        <div className={styles.cluster}>
          {parsedStartTime && (
            <Countdown
              clampClassName={styles.countdown}
              scheduledStartTime={parsedStartTime}
            />
          )}
          {to && (
            <div className={styles.link}>
              <Icon type="arrow-right" inline />
            </div>
          )}
        </div>
      )}
    </>
  );

  if (to) {
    return (
      <Link className={styles.row} to={to}>
        {rowContents}
      </Link>
    );
  }

  return <div className={styles.row}>{rowContents}</div>;
};
